// Models
import { DeviceModel, DeviceViewModel } from '../models/device.model';

export namespace DeviceActions {
	export class GetAll {
		static readonly type = '[Device] Get Devices';
		constructor(public data: { showSpinner?: boolean; showToast?: boolean } = { showSpinner: false, showToast: false }) {}
	}
	
	export class SetAll {
		static readonly type = '[Device] Set Devices';
		constructor(public devices: DeviceViewModel[]) {}
	}
	
	export class GetTypes {
		static readonly type = '[Device] Get Device Types';
		constructor(public data: { showSpinner?: boolean; showToast?: boolean } = { showSpinner: false, showToast: false }) {}
	}
	
	export class Create {
		static readonly type = '[Device] Create Device';
		constructor(public data: { device: DeviceModel; showSpinner?: boolean; showToast?: boolean } = { device: null, showSpinner: false, showToast: false }) {}
	}
	
	export class CreateSuccess {
		static readonly type = '[Device] Create Device Success';
		constructor(public device: DeviceViewModel) {}
	}
	
	export class CreateError {
		static readonly type = '[Device] Create Device Error';
	}
	
	export class Update {
		static readonly type = '[Device] Update Device';
		constructor(public data: { device: DeviceViewModel; showSpinner?: boolean; showToast?: boolean } = { device: null, showSpinner: false, showToast: false }) {}
	}
	
	export class UpdateSuccess {
		static readonly type = '[Device] Update Device Success';
		constructor(public device: DeviceViewModel) {}
	}
	
	export class UpdateError {
		static readonly type = '[Device] Update Device Error';
	}
	
	export class Delete {
		static readonly type = '[Device] Delete Device';
		constructor(public data: { machineName: string; showSpinner?: boolean; showToast?: boolean; showConfirm: boolean } = { machineName: null, showSpinner: false, showToast: false, showConfirm: false }) {}
	}
}